import { MessageBox, Message } from "element-ui";
// import tagsview from "../store/modules/tagsView"
const showMsgList = [
  { msgtype: 1, msg: "拒绝时，备注必须填写", type: "error" },
  { msgtype: 2, msg: "审核完成", type: "success" },
  { msgtype: 3, msg: "信息保存成功", type: "success" },
  { msgtype: 4, msg: "信息修改成功", type: "success" },
  { msgtype: 5, msg: "请确认删除", type: "error" },
  { msgtype: 6, msg: "信息删除成功", type: "success" },
  { msgtype: 7, msg: "查询无数据", type: "error" },
  { msgtype: 8, msg: "数据异常", type: "error" },
  { msgtype: 9, msg: "文件未上传或未上传完成，请稍后再试", type: "error" },
  { msgtype: 10, msg: "用户无权限", type: "error" }
];

function getShowMsg(obj) {
  let _obj = {};
  _obj = obj;
  if (obj.msgtype) {
    showMsgList.forEach(item => {
      if (obj.msgtype === item.msgtype) {
        _obj = item;
      }
    });
  }
  return _obj;
}

export function Confirm(obj, callBack, errBack) {
  const title = obj.title ? obj.title : "请确认";
  const csclass = obj.csclass ? obj.csclass : "";
  const msg = getShowMsg(obj);
  MessageBox.confirm(msg.msg, title, {
    dangerouslyUseHTMLString: true,
    customClass: csclass,
    showClose: false,
    closeOnPressEscape: false,
    closeOnClickModal: false,
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      if (callBack && typeof callBack === "function") {
        callBack();
      }
    })
    .catch(() => {
      if (errBack && typeof errBack === "function") {
        errBack();
      }
    });
}

export function SuccessAlert(obj, callBack) {
  const title = obj.title ? obj.title : "请求成功";
  const msg = getShowMsg(obj);
  MessageBox.confirm(msg.msg, title, {
    showClose: false,
    closeOnPressEscape: false,
    closeOnClickModal: false,
    showCancelButton: false,
    confirmButtonText: "确定",
    type: "success"
  }).then(() => {
    if (typeof callBack === "function") {
      callBack();
    }
  });
}

export function SoftAlert(obj) {
  const msg = getShowMsg(obj);
  Message({
    dangerouslyUseHTMLString: true,
    message: msg.msg,
    type: msg.type,
    duration: (obj.time * 1000) | (5 * 1000),
    showClose: true
  });
}
export function ClosePage(events, path) {
  events.$store.dispatch("tagsView/delView", events.$route);
  events.$router.push(path);
}
// 字符串
// this.$router.push('home')
// 对象
// this.$router.push({ path: 'home' })
// 命名的路由
// this.$router.push({ name: 'user', params: { userId: '123' }})
// this.$router.replace({ name: 'user', params: { userId: '123' }}) // 后退不显示此页面
// 带查询参数，变成 /register?plan=private
// this.router.push({ path: 'register', query: { plan: 'private' }})
// <router-link to="/" />
export function PushPage(events, path, clospage) {
  if (clospage) {
    events.$store.dispatch("tagsView/delView", events.$route);
  }
  // 判断当前页面是否需要缓存
  const keepalivemenu = events.$store.state.user.keepalivemenu;
  const iskeep = keepalivemenu.find(item => item.routeName === path.name);
  if (iskeep) {
    // 需要缓存,判断当前缓存页面是否已打开
    const showingtagview = events.$store.state.tagsView.visitedViews;
    const isshow = showingtagview.find(item => item.name === iskeep.routeName);
    if (isshow) {
      // 如果已打开，需要先清楚该缓存
      events.$store.dispatch("tagsView/delCachedView", isshow);
    }
  }
  // 定时50微妙执行，先执行appMain中的cachedViews方法  去除缓存
  setTimeout(() => {
    events.$router.push(path);
  }, 50);
}
